import { Component, computed, forwardRef, input } from "@angular/core";
import { CastBlockItemPipe } from "../../../../common/pipes/cast-block-item.pipe";
import { BlockCollectionTypes } from "../../../api/common/model-enums/block-collection-types.enum";
import { ItemsAdLayoutBlockBlocksRefs } from "../../../api/packbo/models/items-ad-layout-block-blocks-refs";
import { ItemsPagesBlocksRefs } from "../../../api/packbo/models/items-pages-blocks-refs";
import { AccordionBlockComponent } from "../accordion-block/accordion-block.component";
import { AdBlockComponent } from "../ad-block/ad-block.component";
import { AdLayoutBlockComponent } from "../ad-layout-block/ad-layout-block.component";
import { AdPackagesBlockComponent } from "../ad-packages-block/ad-packages-block.component";
import { BronzeSubscriptionFormBlockComponent } from "../bronze-subscription-form-block/bronze-subscription-form-block.component";
import { ButtonBlockComponent } from "../button-block/button-block.component";
import { ConfirmationBlockComponent } from "../confirmation-block/confirmation-block.component";
import { ContactFormBlockComponent } from "../contact-form-block/contact-form-block.component";
import { FundingBlockComponent } from "../funding-block/funding-block.component";
import { HeaderBlockComponent } from "../header-block/header-block.component";
import { LandingPageSplitBlockComponent } from "../landing-page-split-block/landing-page-split-block.component";
import { PackageBlockComponent } from "../package-block/package-block.component";
import { PartnerBlockComponent } from "../partner-block/partner-block.component";
import { ProductCategoriesBlockComponent } from "../product-categories-block/product-categories-block.component";
import { ResourceBlockComponent } from "../resource-block/resource-block.component";
import { RitchtextBlockComponent } from "../ritchtext-block/ritchtext-block.component";
import { SupplierShowcaseBlockComponent } from "../supplier-showcase-block/supplier-showcase-block.component";

@Component({
    selector: "packbo-dynamic-page",
    templateUrl: "./dynamic-page.template.html",
    imports: [
        HeaderBlockComponent,
        ButtonBlockComponent,
        CastBlockItemPipe,
        LandingPageSplitBlockComponent,
        ProductCategoriesBlockComponent,
        AdBlockComponent,
        SupplierShowcaseBlockComponent,
        RitchtextBlockComponent,
        PartnerBlockComponent,
        FundingBlockComponent,
        ResourceBlockComponent,
        forwardRef(() => AdLayoutBlockComponent),
        forwardRef(() => AccordionBlockComponent),
        ContactFormBlockComponent,
        ConfirmationBlockComponent,
        PackageBlockComponent,
        AdPackagesBlockComponent,
        BronzeSubscriptionFormBlockComponent
    ]
})
export class DynamicPageComponent {
    public readonly blocks = input<ItemsPagesBlocksRefs[] | ItemsAdLayoutBlockBlocksRefs[]>();
    public readonly BlockCollectionTypes = BlockCollectionTypes;

    public readonly enhancedBlocks = computed(() => {
        const blocks = this.blocks() || [];
        const accordionIndices: number[] = [];
        const resourceIndices: number[] = [];
        const packageIndices: number[] = [];

        for (const [index, block] of blocks.entries()) {
            if (block.collection === BlockCollectionTypes.ACCORDION_BLOCK) {
                accordionIndices.push(index);
            }
            if (block.collection === BlockCollectionTypes.RESOURCE_BLOCK) {
                resourceIndices.push(index);
            }
            if (block.collection === BlockCollectionTypes.PACKAGE_BLOCK) {
                packageIndices.push(index);
            }
        }

        return blocks.map((block, index) => ({
            ...block,
            isLastAccordion: accordionIndices.length > 0 && accordionIndices[accordionIndices.length - 1] === index,
            isLastResource:
                resourceIndices.length > 0 &&
                resourceIndices[resourceIndices.length - 1] === index &&
                blocks.length > 1,
            isFirstPackage: packageIndices.length > 0 && packageIndices[0] === index && blocks.length > 1
        }));
    });
}
